import { c as _c } from "react/compiler-runtime";
import { MenuItem, ShareLinkIcon } from "@flat-ui";
import { ProjectShareDialog } from "@pages/projects/project-share-dialog";
import { useState } from "react";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { ProjectEvents } from "@utils/track-event/track-event-list";
/** Renders the share project option menu item */
export function ShareProjectOption(t0) {
  const $ = _c(12);
  const {
    project,
    onClose
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  let t1;
  if ($[0] !== project.id || $[1] !== trackEvent) {
    t1 = function onClick() {
      setIsDialogOpen(true);
      trackEvent({
        name: ProjectEvents.openShareProject,
        props: {
          projectId: project.id,
          location: "projects-action"
        }
      });
    };
    $[0] = project.id;
    $[1] = trackEvent;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onClick = t1;
  let t2;
  if ($[3] !== onClose) {
    t2 = function handleClose() {
      setIsDialogOpen(false);
      onClose?.();
    };
    $[3] = onClose;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleClose = t2;
  let t3;
  if ($[5] !== onClick) {
    t3 = <MenuItem label="Share" Icon={ShareLinkIcon} onClick={onClick} />;
    $[5] = onClick;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== handleClose || $[8] !== isDialogOpen || $[9] !== project || $[10] !== t3) {
    t4 = <ProjectShareDialog project={project} isOpen={isDialogOpen} onClose={handleClose}>{t3}</ProjectShareDialog>;
    $[7] = handleClose;
    $[8] = isDialogOpen;
    $[9] = project;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}